import { IHistoryFreeType, IHistoryNiche, IHistoryTag, IHistoryUser } from "@/common/services/types";
import { TagCard } from "../TagCard";
import { ProfileCard } from "../ProfileCard";
import { NicheCard } from "../NicheCard";
import { FreeTextCard } from "../FreeTextCard";
import { useSearchHistoryItem } from "./hooks/useSearchHistoryItem";
import { useSfw } from "@/common/hooks/useSfw";

interface ISearchHistoryItem {
  data: IHistoryUser | IHistoryFreeType | IHistoryNiche | IHistoryTag;
}

export const SearchHistoryItem = ({ data }: ISearchHistoryItem) => {
  const { handleClick } = useSearchHistoryItem();
  const { sanitizeImage } = useSfw();

  switch (data.type) {
  case "tag": {
    const { tag } = data as IHistoryTag;

    if (!tag) {
      return null;
    }

    return (
      <TagCard
        tagName={tag.name}
        qty={tag.count}
        onClick={() => handleClick(tag.name, tag.name)}
      />
    );
  }
  case "user": {
    const { account: { verified, studio, followers, name, username, profileImageUrl } } = data as IHistoryUser;
    const sanitizedAvatar = profileImageUrl ? sanitizeImage(profileImageUrl) : null;

    return (
      <ProfileCard
        verified={verified}
        followers={followers}
        userName={name}
        profileImageUrl={sanitizedAvatar}
        isStudio={!!studio}
        userId={username}
        hasSubscribeMsg
        onClick={() => handleClick(name, username)}
      />
    );
  }
  case "niche": {
    const { niche: { id, subscribers, thumbnail, name } } = data as IHistoryNiche;
    const sanitizedThumbnail = thumbnail ? sanitizeImage(thumbnail) : null;

    return (
      <NicheCard
        id={id}
        nicheImageUrl={sanitizedThumbnail}
        followers={subscribers}
        nicheName={name}
        onClick={() => handleClick(name, id)}
      />
    );
  }
  case "free_type": {
    const { value } = data as IHistoryFreeType;
    return (
      <FreeTextCard
        text={value}
        onClick={() => handleClick(value)}
      />
    );
  }
  default: {
    return null;
  }
  }
};
